import React from 'react';
import { Logo } from '../ui';
import { MenuIcon, CheckCircle2Icon, MessageSquareIcon, PlayIcon, PauseIcon, PresentationIcon, HeadphonesIcon, VideoIcon, ChevronRightIcon } from 'lucide-react';
export function ParticipantPreview() {
  return <div className="bg-white rounded-2xl shadow-soft p-8 border border-slate-100" data-id="element-1645">
      <h2 className="text-xl font-bold text-brand-navy mb-6 text-center" data-id="element-1646">
        Participant View Preview
      </h2>

      <div className="flex justify-center" data-id="element-1647">
        {/* Phone Mockup */}
        <div className="relative w-80 h-[680px] bg-slate-900 rounded-[3rem] p-3 shadow-2xl" data-id="element-1648">
          {/* Notch */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-7 bg-slate-900 rounded-b-3xl z-10" data-id="element-1649"></div>

          {/* Screen */}
          <div className="w-full h-full bg-white rounded-[2.5rem] overflow-y-auto" data-id="element-1650">
            <div className="p-5 space-y-4" data-id="element-1651">
              {/* Top Bar */}
              <div className="flex items-center justify-between pb-4 border-b border-slate-100" data-id="element-1652">
                <div className="scale-75 origin-left" data-id="element-1653">
                  <Logo data-id="element-1654" />
                </div>
                <button className="p-2" data-id="element-1655">
                  <MenuIcon className="w-5 h-5 text-slate-600" data-id="element-1656" />
                </button>
              </div>

              {/* Welcome Card */}
              <div className="bg-gradient-to-br from-brand-navy to-brand-teal text-white p-5 rounded-2xl" data-id="element-1657">
                <div className="text-sm font-medium mb-1" data-id="element-1658">
                  Welcome, Sarah 👋
                </div>
                <div className="text-lg font-bold" data-id="element-1659">
                  Day 1 of Leadership Reset
                </div>
              </div>

              {/* Event Agenda */}
              <div className="bg-white border border-slate-200 rounded-xl p-4" data-id="element-1660">
                <h3 className="font-bold text-sm text-brand-navy mb-3" data-id="element-1661">
                  Today's Agenda
                </h3>
                <div className="space-y-3" data-id="element-1662">
                  <AgendaItem time="9:00 AM" label="Welcome circle" data-id="element-1663" />
                  <AgendaItem time="10:30 AM" label="Team Trust workshop" data-id="element-1664" />
                  <AgendaItem time="2:00 PM" label="Wellness break" data-id="element-1665" />
                </div>
              </div>

              {/* Introduction Prompt */}
              <div className="bg-brand-teal/5 border border-brand-teal/20 rounded-xl p-4" data-id="element-1666">
                <div className="flex items-center gap-2 mb-2" data-id="element-1667">
                  <MessageSquareIcon className="w-4 h-4 text-brand-teal" data-id="element-1668" />
                  <h3 className="font-bold text-sm text-brand-navy" data-id="element-1669">
                    Introduction Prompt
                  </h3>
                </div>
                <p className="text-sm text-slate-700 mb-3" data-id="element-1670">
                  Share one thing you hope to leave with this week
                </p>
                <textarea className="w-full text-xs border border-slate-200 rounded-lg p-2 resize-none" rows={2} placeholder="Type your response..." data-id="element-1671" />
              </div>

              {/* Learning Prompt */}
              <div className="bg-brand-coral/5 border border-brand-coral/20 rounded-xl p-4" data-id="element-1672">
                <div className="flex items-center gap-2 mb-2" data-id="element-1673">
                  <span className="text-brand-coral text-lg" data-id="element-1674">💭</span>
                  <h3 className="font-bold text-sm text-brand-navy" data-id="element-1675">
                    Today's Reflection
                  </h3>
                </div>
                <p className="text-sm text-slate-700 italic" data-id="element-1676">
                  "When did you last feel deeply trusted at work?"
                </p>
              </div>

              {/* Slides — Today's session deck */}
              <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-id="element-1677">
                <div className="relative aspect-[4/3] bg-gradient-to-br from-brand-navy via-slate-800 to-brand-teal text-white p-4 flex flex-col justify-between" data-id="element-1678">
                  <div className="flex items-center justify-between text-[10px] font-bold uppercase tracking-wider" data-id="element-1679">
                    <span className="flex items-center gap-1.5 text-teal-300" data-id="element-1680">
                      <PresentationIcon className="w-3 h-3" data-id="element-1681" /> Slides · 4 of 18
                    </span>
                    <span className="text-slate-300" data-id="element-1682">Leadership Reset</span>
                  </div>
                  <div data-id="element-1683">
                    <div className="text-[10px] font-bold uppercase tracking-wider text-brand-coral mb-1.5" data-id="element-1684">
                      Pillar 02
                    </div>
                    <div className="text-sm font-bold leading-snug mb-1" data-id="element-1685">
                      Trust is the multiplier of every team decision.
                    </div>
                    <div className="text-[10px] text-slate-300" data-id="element-1686">
                      Press space to advance →
                    </div>
                  </div>
                  <div className="absolute bottom-2 left-3 right-3 flex gap-1" data-id="element-1687">
                    {Array.from({
                    length: 6
                  }).map((_, i) => <div key={i} className={`flex-1 h-0.5 rounded-full ${i < 3 ? 'bg-white' : 'bg-white/25'}`} data-id="element-1688" />)}
                  </div>
                </div>
                <div className="p-3 flex items-center justify-between" data-id="element-1689">
                  <div data-id="element-1690">
                    <div className="text-xs font-bold text-brand-navy" data-id="element-1691">
                      Today's session deck
                    </div>
                    <div className="text-[10px] text-slate-500" data-id="element-1692">
                      18 slides · 12 min read
                    </div>
                  </div>
                  <button className="text-[10px] font-bold text-brand-teal flex items-center gap-1" data-id="element-1693">
                    Open <ChevronRightIcon className="w-3 h-3" data-id="element-1694" />
                  </button>
                </div>
              </div>

              {/* Video — pre-event briefing */}
              <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-id="element-1695">
                <div className="relative aspect-video bg-slate-900 overflow-hidden group" data-id="element-1696">
                  <img src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=600&auto=format&fit=crop" alt="" className="w-full h-full object-cover opacity-70" data-id="element-1697" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" data-id="element-1698" />
                  <button className="absolute inset-0 flex items-center justify-center" data-id="element-1699">
                    <span className="w-12 h-12 rounded-full bg-white/95 text-brand-navy flex items-center justify-center shadow-xl" data-id="element-1700">
                      <PlayIcon className="w-5 h-5 ml-0.5 fill-current" data-id="element-1701" />
                    </span>
                  </button>
                  <div className="absolute top-2 left-2 flex items-center gap-1.5 bg-black/40 backdrop-blur text-white text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full" data-id="element-1702">
                    <VideoIcon className="w-3 h-3 text-brand-coral" data-id="element-1703" /> Video ·
                    4:12
                  </div>
                  <div className="absolute bottom-2 left-3 right-3 text-white" data-id="element-1704">
                    <div className="text-[10px] font-bold text-teal-300 uppercase tracking-wider mb-0.5" data-id="element-1705">
                      Pre-event briefing
                    </div>
                    <div className="text-xs font-bold leading-tight" data-id="element-1706">
                      A note from your facilitator
                    </div>
                  </div>
                </div>
              </div>

              {/* Audio — guided reflection */}
              <div className="bg-brand-navy text-white rounded-xl p-4" data-id="element-1707">
                <div className="flex items-center gap-3 mb-3" data-id="element-1708">
                  <div className="w-10 h-10 rounded-full bg-brand-teal/20 flex items-center justify-center text-brand-teal shrink-0" data-id="element-1709">
                    <HeadphonesIcon className="w-5 h-5" data-id="element-1710" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-1711">
                    <div className="text-[10px] font-bold uppercase tracking-wider text-teal-300" data-id="element-1712">
                      Audio · Guided
                    </div>
                    <div className="text-sm font-bold truncate" data-id="element-1713">
                      5-minute morning reset
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-1714">
                  <button className="w-9 h-9 rounded-full bg-brand-coral text-white flex items-center justify-center shrink-0" data-id="element-1715">
                    <PlayIcon className="w-4 h-4 ml-0.5 fill-current" data-id="element-1716" />
                  </button>
                  <div className="flex-1" data-id="element-1717">
                    <div className="w-full h-1 bg-white/15 rounded-full overflow-hidden" data-id="element-1718">
                      <div className="h-full bg-brand-teal rounded-full w-[28%]" data-id="element-1719" />
                    </div>
                    <div className="flex justify-between text-[10px] text-slate-400 font-mono mt-1" data-id="element-1720">
                      <span data-id="element-1721">1:24</span>
                      <span data-id="element-1722">5:00</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Activity Signup */}
              <div className="bg-white border border-slate-200 rounded-xl p-4" data-id="element-1723">
                <h3 className="font-bold text-sm text-brand-navy mb-3" data-id="element-1724">
                  Choose your Day 2 morning activity
                </h3>
                <div className="space-y-2" data-id="element-1725">
                  <ActivityOption label="Sunrise yoga" selected data-id="element-1726" />
                  <ActivityOption label="Beach hike" data-id="element-1727" />
                  <ActivityOption label="Quiet journaling" data-id="element-1728" />
                </div>
              </div>

              {/* Reflection Question */}
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-4" data-id="element-1729">
                <h3 className="font-bold text-sm text-brand-navy mb-2" data-id="element-1730">
                  Commitment
                </h3>
                <p className="text-xs text-slate-600 mb-3" data-id="element-1731">
                  What's one commitment you'll take home?
                </p>
                <textarea className="w-full text-xs border border-slate-200 rounded-lg p-2 resize-none bg-white" rows={3} placeholder="Write your commitment..." data-id="element-1732" />
              </div>

              {/* Group Assignment */}
              <div className="bg-brand-navy text-white rounded-xl p-4" data-id="element-1733">
                <div className="flex items-center gap-2 mb-2" data-id="element-1734">
                  <CheckCircle2Icon className="w-4 h-4 text-brand-teal" data-id="element-1735" />
                  <h3 className="font-bold text-sm" data-id="element-1736">You're in Pod #3</h3>
                </div>
                <p className="text-xs text-slate-300 mb-3" data-id="element-1737">
                  Meet at the palm courtyard, 4pm
                </p>
                <div className="flex -space-x-2" data-id="element-1738">
                  {[1, 2, 3, 4, 5, 6].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-brand-navy bg-slate-200 overflow-hidden" data-id="element-1739">
                      <img src={`https://i.pravatar.cc/100?img=${i + 30}`} alt="" className="w-full h-full object-cover" data-id="element-1740" />
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="text-center text-sm text-slate-500 mt-6" data-id="element-1741">
        Mobile-optimized experience for attendees before, during, and after the
        event
      </p>
    </div>;
}
function AgendaItem({
  time,
  label
}: any) {
  return <div className="flex items-center gap-3" data-id="element-1742">
      <div className="text-xs font-mono text-slate-500 w-16" data-id="element-1743">{time}</div>
      <div className="flex-1 text-sm text-slate-700" data-id="element-1744">{label}</div>
    </div>;
}
function ActivityOption({
  label,
  selected
}: any) {
  return <label className="flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50 cursor-pointer" data-id="element-1745">
      <input type="radio" name="activity" checked={selected} className="w-4 h-4 text-brand-teal" readOnly data-id="element-1746" />
      <span className="text-sm text-slate-700" data-id="element-1747">{label}</span>
    </label>;
}